import { render } from "./app-sidebar-item-brand.vue?vue&type=template&id=1ffaf15e"
import script from "./app-sidebar-item-brand.vue?vue&type=script&lang=js"
export * from "./app-sidebar-item-brand.vue?vue&type=script&lang=js"
script.render = render

export default script